<template>
  <card className="card">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="m-0">Log Employee</h5>
      <button @click="toggleLog" class="btn btn-toggle-log d-flex align-items-center p-0">
        <p class="m-0 text-small">Hide</p>
        <div
          :class="[
            !showLog ? 'hide-icon-show' : 'hide-icon-collapse',
            'hide-icon',
          ]"
        >
          <i class="fa fa-chevron-right"></i>
        </div>
      </button>
    </div>
    <div v-if="showLog" class="table-wrapper mt-2">
      <hr style="margin: 0" />
      <div class="row table-header m-0">
        <div class="col-4 py-2 px-3">
          <p class="m-0">When</p>
        </div>
        <div class="col-5 py-2 px-3">
          <p class="m-0">What</p>
        </div>
        <div class="col-3 py-2 px-3">
          <p class="m-0">Who</p>
        </div>
      </div>
      <div style="max-height: 200px; overflow-y: auto;">
        <div
          v-for="(item, index) in logData"
          :key="index"
          class="table-content row m-0"
        >
          <div class="col-4 py-2 px-3">
            <p class="m-0">{{ item.time }}</p>
          </div>
          <div class="col-5 py-2 px-3">
            <p class="m-0">{{ item.text }}</p>
          </div>
          <div class="col-3 py-2 px-3">
            <p class="m-0">{{ item.ids }}</p>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import { Card } from "../../Layout";
export default {
  name: "TableWrapper",
  components: {
    Card,
  },
  props: {
    logData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showLog: true,
    };
  },
  methods: {
    toggleLog() {
      this.showLog = !this.showLog;
    },
  },
};
</script>

<style scoped>
.card {
  padding: 10px 16px !important;
}

.text-small {
  font-size: 12px;
}

.hide-icon {
  font-size: 10px;
  margin-left: 8px;
}

.hide-icon-show {
  transform: rotate(90deg);
}

.hide-icon-collapse {
  transform: rotate(-90deg);
}

h5 {
  font-weight: 600;
  font-size: 16px;
}

.table-wrapper {
  border: 1px solid #cfd3d9;
  border-radius: 8px;
  overflow: hidden;
}

.table-title {
  background-color: #f8f9fa;
}

.table-title h6 {
  margin: 0;
}

.table-header p {
  font-weight: 700;
  font-size: 14px;
  color: #374151;
}

.table-content:nth-child(even) {
  background-color: #f8f9fa;
}

.table-content:nth-child(odd) {
  background-color: #ffffff;
}

.table-content p {
  font-weight: 500;
  font-size: 14px;
  color: #374151;
}

.table-header {
  background-color: #f8f9fa;
}

.btn-toggle-log:focus {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Employee/Components/EmployeeLog.vue